export const API_URL_DEV = 'https://dev-be.exacture.io/main-api/';

export const API_URL = process.env.REACT_APP_API_URL || API_URL_DEV;
